import { Getters } from 'vuex-smart-module';
import { StepManagerState } from '@/store/step-manager/state';

export class StepManagerGetters extends Getters<StepManagerState> {
	get dealProgressStatus() {
		return this.state.dealProgressStatus;
	}

	get isLoading() {
		return this.state.isLoading;
	}
}
